/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PreviousAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import ArrowLeft from 'DesignSystem/Svgs/ArrowLeft/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'



/** @type {import('Simple/types.js').View} */
export default function PreviousAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Images/ActiveTab/Images/Content/Content/Content/Preview/Content/Content/PreviousAction"
  
}) {
let patientImagesValueData = fromData.useDataValue({ viewPath,
context: 'patient_images',
})
let tabImageIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'image_id',
})
let aggregateData = fromHelpers.isDisabled(patientImagesValueData, tabImageIdValueData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 alignSelf="center"
 marginRight={dtSpaceXs}
 marginLeft={dtSpaceXs}
 data="patient_images"
 data="tab.image_id"
 aggregate="helpers.js isDisabled"
 disabled={aggregateData}
 onClick={onClick}
 type="secondary"
 size="small"
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<ArrowLeft
{...childProps}
  viewPath={`${viewPath}/ArrowLeft`}
 fill="none"
 stroke={dtColorsNeutral700}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
{children}
</React.Fragment>)
}